<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.event')}}</div>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-autocomplete
                            v-model="event"
                            item-text="name"
                            item-value="id"
                            :label="__('labels.event_event')"
                            :items="events"
                            :rules="rules.event">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs12 v-for="(performanceDate, index) in performanceDates"
                        :key="index">
                    <s-performance-date-field
                            :date="performanceDate"
                            :index="index"
                    >
                    </s-performance-date-field>
                </v-flex>
                <v-flex xs12>
                    <v-btn
                            color="primary"
                            @click="addPerformanceDate"
                    >
                        {{__('labels.event_add_performance_date')}}
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "EventStep",
        computed: {
            ...mapState('form', [
                'events',
                'locations',
                'performanceDates',
                'address',
            ]),
            event: {
                get() {
                    return this.$store.state.form.event;
                },
                set(v) {
                    this.$store.dispatch('form/setEvent', v);
                }
            },
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({
                        event: ['required'],
                    }
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            ...mapMutations('form', [
                'addPerformanceDate',
                "setTravelingExpenses",
                "setMiscTravelingExpenses"
            ]),
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                    let firstDate = flattenedDates[0]
                    if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))) {
                        this.setTravelingExpenses({
                            train: {netto: null, brutto: null, taxes: 5, name: this.__('invoices.train')},
                            plane: {netto: null, brutto: null, taxes: 16, name: this.__('invoices.plane')},
                            car: {km: null, netto: null, brutto: null, name: this.__('invoices.car')},
                            bus: {netto: null, brutto: null, taxes: 5, name: this.__('invoices.bus')},
                            taxi: {netto: null, brutto: null, taxes: 5, name: this.__('invoices.taxi')},
                            parking: {netto: null, brutto: null, taxes: 16, name: this.__('invoices.parking')},
                        })
                    } else {
                        this.setTravelingExpenses({
                            train: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.train')},
                            plane: {netto: null, brutto: null, taxes: 19, name: this.__('invoices.plane')},
                            car: {km: null, netto: null, brutto: null, name: this.__('invoices.car')},
                            bus: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.bus')},
                            taxi: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.taxi')},
                            parking: {netto: null, brutto: null, taxes: 19, name: this.__('invoices.parking')},
                        })
                    }
                    this.setMiscTravelingExpenses([])
                    this.$cookies.set('event', this.event);
                    this.$cookies.set('performanceDates', JSON.stringify(this.performanceDates));
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>